<template>
    <div id="vehicle_model_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="fuelHeaderupdate" v-if="$route.params.id > 0">Update Fuel Drop</span>
                    <span class="page-title" id="fuelHeaderCreate" v-else>Add Fuel drop</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackDroplList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="fuelDropCreate">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="product_id">Product:</label>
                                        <v-select v-model="product_id" name="product_id" placeholder="Select Product"
                                                    label="text"
                                                    :options="productArr | fuelProd" @input="onSelectProduct()">
                                        </v-select>
                                        <div class="field-error">{{ tank_no_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="tank_mapper_id">Tank:</label>
                                        <v-select v-model="tank_mapper_id" name="tank_mapper_id" placeholder="Select Tank"
                                                    label="text"
                                                    :options="tankMapperArr" >
                                        </v-select>
                                        <div class="field-error">{{ tank_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="date_time">Date Time:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="date_time" name="date_time" v-model="date_time" :config="optionsDate"></date-picker>
                                            <label for="date_time" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ date_time_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="capacity">Quantity:</label>
                                        <input type="number" class="form-control" v-model="quantity" id="quantity" placeholder="Enter quantity" name="quantity" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{quantity_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="unit_id">UOM:</label>
                                        <v-select v-model="measurement_unit_id" name="unit_id" placeholder="Select UOM"
                                                    label="text"
                                                    :options="vomArr">
                                        </v-select>
                                        <div class="field-error">{{ measurement_unit_error_msg }}</div>
                                    </div>
                                     <!-- <div class="col form-group">
                                        <label class="control-label require" for="status">Status:</label>
                                        <v-select :disabled="!isNotProcessed" v-model="status" name="status" @input="onChangeStatus($event)" placeholder="Select status"
                                                    label="text"
                                                    :options="statusArr">
                                        </v-select>
                                        <div class="field-error">{{ status_error_msg }}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="user_id">User:</label>
                                        <v-select v-model="user_id" name="user_id" id="user_id"
                                                    label="text" :filterable="false" :options="userArr"
                                                    @search="onSearchUser"
                                                    placeholder="Select User" class='custom-ci-auto-search contract-data close-remove'>
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ user_error_msg }}</div>
                                    </div>
                                    <div class="col form-group pt-md-4">
                                        <div class="custom-checkbox">
                                            <label for="is_recieved" class="checkbox-custom">Drop Received
                                            <input type="checkbox" v-model="is_recieved" id="is_recieved" name="is_recieved" v-on:click="isRecieved($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col form-group" v-if="is_recieved">
                                        <label :class="'control-label '+isRequired" for="cost">Estimated Cost (Per Gallon) :</label>
                                        <input type="number" class="form-control" v-model="cost" id="cost" placeholder="Enter Cost" name="cost" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{cost_error_msg}}</div>
                                    </div>
                                    <div v-if="isRequired != 'require' && actualRequire == ''" style="clear:both"></div>
                                    <!-- <div style="clear:both"></div> -->

                                    <div class="col form-group" v-if="$route.params.id != undefined && status.value =='received'">
                                        <label class="control-label" for="cost">Actual Price :</label>
                                        <input type="number" class="form-control" v-model="actual_price" id="actual_price" placeholder="Enter Actual Price" name="actual_price" @keypress="isAmountCheck($event)" @blur="changeActualPrice()">
                                        <div class="field-error">{{actual_price_error_msg}}</div>
                                    </div>

                                    <div class="col form-group" v-if="$route.params.id != undefined && status.value =='received'">
                                        <label class="control-label"> Voucher </label>
                                        <v-select v-model="bill_id" id="bill_id" name="bill_id" label="text" :filterable="false" :options="billArr" @search="onSearchBill" placeholder="Select Vendor Invoice" class="custom-ci-auto-search" @input="onSelectBill()">
                                            <template slot="no-options">
                                                Search Vendor Invoice...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{bill_id_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="$route.params.id != undefined && status.value =='received'">
                                        <label :class="'control-label '+actualRequire" for="cost">Invoice Number :</label>
                                        <input type="text" class="form-control" v-model="inv_number" id="inv_number" placeholder="Enter Invoice Number" name="inv_number">
                                         <div class="field-error">{{inv_number_error}}</div>
                                    </div>

                                    <div class="col form-group" v-if="$route.params.id != undefined && status.value =='received'">
                                        <label :class="'control-label '+actualRequire"> Vendor </label>
                                        <v-select v-model="vendor_id" id="vendor" name="vendor" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vendor...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{vendor_error_msg}}</div>
                                    </div>

                                    <div class="col form-group" v-if="is_recieved">
                                        <label class="control-label" for="cost">Federal Diesel Excise Tax :</label>
                                        <input type="number" class="form-control" v-model="federal_diesel_excise_tax" id="federal_diesel_excise_tax" placeholder="Enter Diesel Excise Tax" name="federal_diesel_excise_tax" :disabled="true">
                                    </div>
                                    <div class="col form-group" v-if="is_recieved">
                                        <label class="control-label" for="cost">Federal L. U. S. T. Tax :</label>
                                        <input type="number" class="form-control" v-model="federal_lust_tax" id="federal_lust_tax" placeholder="Enter L U S T Tax" name="federal_lust_tax" :disabled="true">
                                    </div>
                                    <div class="col form-group" v-if="is_recieved">
                                        <label class="control-label" for="cost">DSL-Fed Enviromental Fee :</label>
                                        <input type="number" class="form-control" v-model="dsl_fed_enviromental_fee" id="dsl_fed_enviromental_fee" placeholder="Enter DSL-Fed Enviromental Fee" name="dsl_fed_enviromental_fee" :disabled="true">
                                    </div>
                                    <div class="col form-group" v-if="is_recieved">
                                        <label class="control-label" for="cost">CA AB32 ENV Surcharge :</label>
                                        <input type="number" class="form-control" v-model="ca_ab32_env_surcharge" id="ca_ab32_env_surcharge" placeholder="Enter CA AB32 ENV Surcharge" name="ca_ab32_env_surcharge" :disabled="true">
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-2" v-if="is_recieved">
<!--                                    <div class="col form-group verification-section-main">-->
<!--                                        <label :class="'control-label '+isRequired">Estimated Document:</label><br/>-->
<!--                                        <div class="custom-upload-container ml-0" data-provides="fileupload">-->
<!--                                            <label for="physicalFiles" class="fileupload-new btn btn-secondary"><i class="fp-upload"></i>Upload</label>-->
<!--                                            <input class="hide" type="file" id="physicalFiles" ref="files" v-on:change="handleFilesUpload()"/>-->
<!--                                            <div class="field-error">{{fileerror_msg}}</div>-->
<!--                                        </div>-->
<!--                                        <template v-if="!isUpdate">-->
<!--                                            <template v-for="(file, key) in filesArr">-->
<!--                                                <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">-->
<!--                                                    <span class="fileupload-preview">{{ file.name }}</span>-->
<!--                                                    <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">-->
<!--                                                        <i class="fp-delete"></i>-->
<!--                                                    </a>-->
<!--                                                </div>-->
<!--                                            </template>-->
<!--                                            <br>-->
<!--                                        </template>-->
<!--                                        <template v-else>-->
<!--                                            <template  v-for="(files, key1) in existFilesArr">-->
<!--                                                <div v-bind:key="key1" class="overflow-hidden">-->
<!--                                                    <div class="file-container pull-left" style="width:60%">-->
<!--                                                        <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(files.url,files.extension)">{{ files.display_name }}</a>-->
<!--                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteFuelDropFile(key1,files.file_name,'estimate')" style="float: right">-->
<!--                                                            <i class="fp-delete"></i>-->
<!--                                                        </a>-->
<!--                                                    </div>-->
<!--                                                    <a href="javascript:void(0)" class="btn btn-secondary ml-2" style="margin-top:12px;" v-on:click="openDocument(files.url,files.extension)">  View & Download</a>-->
<!--                                                </div>-->
<!--                                            </template>-->
<!--                                        </template>-->
<!--                                    </div>-->
<!--                                    <div class="col form-group verification-section-main" v-if="$route.params.id != undefined && status.value =='received'">-->
<!--                                        <label :class="'control-label '+actualRequire"> Actual Document:</label><br/>-->
<!--                                        <div class="custom-upload-container ml-0" data-provides="fileupload">-->
<!--                                            <label for="physicalAcFiles" class="fileupload-new btn btn-secondary"><i class="fp-upload"></i>Upload</label>-->
<!--                                             &lt;!&ndash; <label for="physicalFiles" class="fileupload-exists btn btn-secondary" v-if="isUpdate"><i class="fp-upload"></i>Change</label> &ndash;&gt;-->
<!--                                            <input class="hide" type="file" id="physicalAcFiles" ref="acfiles" v-on:change="handleAcFilesUpload()"/>-->
<!--                                            <div class="field-error">{{ac_fileerror_msg}}</div>-->
<!--                                        </div>-->
<!--                                        <template v-if="!acUpadate">-->
<!--                                            <template v-for="(acfile, ackey) in acfilesArr">-->
<!--                                                <div v-bind:key="ackey" class="file-container" :id="'fileDiv'+acfile.id">-->
<!--                                                    <span class="fileupload-preview">{{ acfile.name }}</span>-->
<!--                                                    <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteAcDoc(acfile.id,key)" style="float: right">-->
<!--                                                        <i class="fp-delete"></i>-->
<!--                                                    </a>-->
<!--                                                </div>-->
<!--                                            </template>-->
<!--                                            <br>-->
<!--                                        </template>-->
<!--                                        <template v-else>-->
<!--                                            <template  v-for="(acfiles, ackey1) in existacFilesArr">-->
<!--                                                <div v-bind:key="ackey1" class="overflow-hidden">-->
<!--                                                    <div class="file-container pull-left" style="width:60%">-->
<!--                                                        <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(acfiles.url,files.extension)">{{ acfiles.display_name }}</a>-->
<!--                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteFuelDropFile(ackey1,acfiles.file_name,'actual')" style="float: right">-->
<!--                                                            <i class="fp-delete"></i>-->
<!--                                                        </a>-->
<!--                                                    </div>-->
<!--                                                    <a href="javascript:void(0)" class="btn btn-secondary ml-2" style="margin-top:12px;" v-on:click="openDocument(acfiles.url,acfiles.extension)">  View & Download</a>-->
<!--                                                </div>-->
<!--                                            </template>-->
<!--                                        </template>-->
<!--                                    </div>-->
                                  <div class="ach-payment-section">
                                    <div class="col form-group verification-section-main">
                                      <label :class="'control-label '+fileRequired">File:</label>
                                      <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                                        <div id="app2">
                                          <vue-dropzone id="vendorInvDocs"
                                                        :options="dropzoneOptions"
                                                        :destroyDropzone=false
                                                        ref="vendorInvDropzone"
                                                        :headers="dropzoneOptions.headers"
                                                        @vdropzone-complete="afterComplete"
                                                        @vdropzone-success="storeDocument"
                                                        @vdropzone-removed-file="removedSelectedFile"
                                          >
                                          </vue-dropzone>
                                          <div class="field-error">{{fileerror_msg}}</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col form-group"  v-if="dropZonePreviewFiles.length > 0">
                                      <div class="policy-attachment attachment-list-box">
                                        <label class="control-label" for="attachments"></label>
                                        <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                          <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                            <i v-if="uFile.ext == 'pdf'" class="fp-pdf-icon"></i>
                                            <i v-if="uFile.ext == 'doc' || uFile.ext == 'docs'" class="fp-text-document"></i>
                                            <i v-if="uFile.ext == 'jpg' ||  uFile.ext == 'png' ||  uFile.ext == 'jpeg' " class="fp-image"></i>
                                            <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.ext)" v-bind:key="'fileName'+fKey" >
                                              {{ uFile.display_name }}
                                            </a>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="deleteFuelDropZoneFile(fKey,uFile.path);">
                                              <i class="fp-close"></i>
                                            </button>
                                          </div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field-error check-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleModelBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateFuelDrop" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleModelBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateFuelDrop" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleModelBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateFuelDrop(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleModelBtn" class="btn btn-tertiary" v-on:click.prevent="BackDroplList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment'
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.min.css";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';


Vue.use(FullCalendar);

//filter product with fuel which is stocked product
Vue.filter('fuelProd', function (objects) {
    return objects.map(function(object, key) {
        if ( object.item_cat_code != null && object.item_cat_code.toLowerCase() == "fuel" ) {
            return object;
        } else {
            objects.splice(key, 1);
        }
    });
});

export default {
  name: "FuelDropCreate",
  components: {
        vueDropzone: vue2Dropzone,
    },
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Fuel Drop Product | " +process.env.COPYRIGHT_NAME : "Create Fuel Drop Product | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    isNotProcessed: true,
    cantAccessPage: "",
    cost:'',
    user_id:null,
    quantity:0,
    userArr:[],
    vomArr:[],
    status: {value: "entered", text: "Entered"},
    statusArr: [
        {
            value: "entered",
            text: "Entered"
        },
        {
            value: "received",
            text: "Received"
        },

    ],
    status_error_msg: "",
    filesArr:[],
    existFilesArr:[],
    measurement_unit_id:null,
    productArr:[],
    product_id:null,
    loading:false,
    optionsDate: {
    format: 'MM/DD/YYYY hh:mm:ss a',
    //          useCurrent: false,
    //          minDate:moment().millisecond(0).second(0).minute(0).hour(0),//new Date(),
    showClose: true,
    },
    date_time:moment().format("MM/DD/YYYY hh:mm:ss a"),
    date_time_error_msg:"",
    cost_error_msg: "",
    fileerror_msg:'',
    ac_fileerror_msg:'',
    quantity_error_msg: "",
    user_error_msg:"",
    tank_no_error_msg: "",
    isUpdate:false,
    measurement_unit_error_msg:"",
    drop_id:0,
    common_error_msg:"",
    billArr:[],
    isRequired:'',
    actualRequire:'',
    bill_id_error_msg:'',
    ac_fileerroor_msg:'',
    actual_price_error_msg:'',
    bill_id:'',
    actual_price:'',
    is_recieved:false,
    acfilesArr:[],
    existacFilesArr:[],
    acUpadate:false,
    uploadacBtn:'',
    federal_diesel_excise_tax:'',
    federal_lust_tax:'',
    dsl_fed_enviromental_fee:'',
    ca_ab32_env_surcharge:'',
    vendor_error_msg:'',
    vendor_id:'',
    vendorArr:[],
    inv_number:'',
    inv_number_error:'',
    tankMapperArr:[],
    tank_mapper_id:'',
    itemCode:'',
    tank_error_msg:'',
    dropzoneOptions: {
        url: process.env.ROOT_API +"/fuel-drop-docs",
        method: 'POST',
        maxFilesize: 10.00, //MB
        maxFiles: 1,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
        headers: {
            'Accept': 'application/json',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
        dictDefaultMessage: "Drop files here to upload. Max allowed file size is 10MB.",
    },
    docArr: [],
    validateDocs: [],
    dropZonePreviewFiles: [],
    fileRequired:'require',
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_drop') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },
        bill_id: function (bill)
        {
            var self = this;

            if (bill == null){
                self.inv_number = '';
                self.vendor_id = '';
            }
        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        self.loadFieldData(['measurementUnit','fuelislandproduct']);

      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      if (userObj != null) {
          var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
          if (dateTimeFormat != null) {
              console.log(dateTimeFormat);
              //set date time format in optionsDate format of date picker
          }
          if(userObj.id){
              self.user_id = {value:userObj.id,text:userObj.first_name+' '+userObj.last_name};
          }
      }

        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadFuelDrop();
            self.isUpdate = true;
            self.drop_id=segments[3];
        }
  },
  methods: {
    isRecieved:function(evt){
        var self = this;

        if (evt.target.checked){
            self.isRequired = 'require';
        }else{
            self.isRequired = '';
        }

    },
    changeActualPrice:function(){
        var self = this;

        if (self.actual_price != '' && self.actual_price > 0){
            self.actualRequire = 'require';
            self.isRequired = '';
        }else{
            self.actualRequire = '';
            if (self.isRecieved){
                self.isRequired = 'require';
            }
        }

    },
    BackDroplList() {
      var self = this;
      self.$router.push("/fuel-drop/list");
    },
    onSearchUser(search, loading) {
          var self = this;
          if (search.length > 0) {

              loading(true);
              self.searchField(loading, search, 'user', '');
          }
    },
    onSearchVendor(search, loading) {
          var self = this;
          if (search.length > 0) {

              loading(true);
              self.searchField(loading, search, 'vendor', '');
          }
    },
      handleFilesUpload: function(event) {
          /* Get the uploaded files from the input.*/
          var self = this;
          if (!self.isUpdate) {

              self.filesArr = [];
              self.fileerroor_msg = "";

              let uploadedFiles = "";
              self.uploadBtn= "Uploading...";
              uploadedFiles = self.$refs.files.files;
              for (var i = 0; i < uploadedFiles.length; i++) {

                  this.filesArr.push(uploadedFiles[i]);

              }
              console.log(this.filesArr);
              this.$refs.files.value = '';
              self.uploadBtn= "Upload";
          }else{

              if (self.existFilesArr!=null && self.existFilesArr.length > 0 ) {

                    if (confirm('Are you sure that you want to upload a file? ')) {

                        self.filesArr = [];
                        self.fileerroor_msg = "";

                        let uploadedFiles = "";
                        self.uploadBtn= "Uploading...";
                        uploadedFiles = self.$refs.files.files;
                        for (var i = 0; i < uploadedFiles.length; i++) {

                            this.filesArr.push(uploadedFiles[i]);

                        }
                        console.log(this.filesArr);
                        this.$refs.files.value = '';
                        self.uploadBtn= "Upload";
                        self.isUpdate = false;
                    }

              }else{
                  self.isUpdate = false;
                  self.filesArr = [];
                  self.fileerroor_msg = "";

                  let uploadedFiles = "";
                  self.uploadBtn= "Uploading...";
                  uploadedFiles = self.$refs.files.files;
                  for (var i = 0; i < uploadedFiles.length; i++) {

                      this.filesArr.push(uploadedFiles[i]);

                  }
                  console.log(this.filesArr);
                  this.$refs.files.value = '';
                  self.uploadBtn= "Upload";
              }

          }

      },

      handleAcFilesUpload: function(event) {
          /* Get the uploaded files from the input.*/
          var self = this;
          if (!self.acUpadate) {

              self.acfilesArr = [];
              self.fileerroor_msg = "";

              let uploadedFiles = "";
              uploadedFiles = self.$refs.acfiles.files;
              for (var i = 0; i < uploadedFiles.length; i++) {

                  this.acfilesArr.push(uploadedFiles[i]);

              }
              console.log(this.acfilesArr);
              this.$refs.acfiles.value = '';
          }else{

              if (self.existFilesArr!=null && self.existFilesArr.length > 0 ) {

                    if (confirm('Are you sure that you want to upload a file? ')) {

                        self.acfilesArr = [];
                        self.fileerroor_msg = "";

                        let uploadedFiles = "";
                        uploadedFiles = self.$refs.acfiles.files;
                        for (var i = 0; i < uploadedFiles.length; i++) {

                            this.acfilesArr.push(uploadedFiles[i]);

                        }
                        console.log(this.filesArr);
                        this.$refs.acfiles.value = '';
                        self.acUpadate = false;
                    }

              }else{
                  self.acUpadate = false;
                  self.acfilesArr = [];
                  self.fileerroor_msg = "";

                  let uploadedacFiles = "";
                  uploadedacFiles = self.$refs.acfiles.files;
                  for (var i = 0; i < uploadedacFiles.length; i++) {

                      this.acfilesArr.push(uploadedacFiles[i]);

                  }
                  this.$refs.acfiles.value = '';
              }

          }

      },
      deleteDoc: function(id,key) {
          var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                console.log( self.$refs.files);
                this.filesArr.splice(key,1)
                self.$refs.files.value = '';
                if (self.valuesFound) {
                    self.valuesFound = false;
                    self.matchingValuesError = [];
                }
            }

            return;

      },
      deleteAcDoc: function(id,key) {
          var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                console.log( self.$refs.acfiles);
                this.acfilesArr.splice(key,1)
                self.$refs.acfiles.value = '';
                // if (self.valuesFound) {
                //     self.valuesFound = false;
                //     self.matchingValuesError = [];
                // }
            }

            return;

      },

      deleteFuelDropFile: function(key,file,from){

            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                if (self.drop_id != '' && self.drop_id != undefined && self.drop_id > 0) {

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/remove-fuel-drop-file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            drop_id:self.drop_id,
                            doc_path:file,
                            from:from
                        },
                        success: function(data) {
                            self.loading = false;
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {

                                self.loadFuelDrop();
                                // $("#myModal").modal("hide");
                                self.$refs.files.value = '';
                                self.existFilesArr = [];
                                if (self.valuesFound) {
                                    self.valuesFound = false;
                                    self.matchingValuesError = [];
                                }
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'fuel-drop-remove');
                            self.filesArr.splice(key,1);
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';


                }
            }

      },
     CreateFuelDrop(flag) {
      var self = this;
      var error = false;

//      self.cost = self.cost.trim();

      self.location_error_msg= "";
      self.status_error_msg= "";
      self.date_time_error_msg= "";
      self.cost_error_msg= "";
      self.quantity_error_msg= "",
      self.user_error_msg="";
      self.tank_no_error_msg="";
      self.item_error_msg="";
      self.measurement_unit_error_msg="";
      self.common_error_msg = "";
      self.ac_fileerror_msg = '';
      self.actual_price_error_msg = '';
      self.ac_fileerroor_msg = '';
      self.bill_id_error_msg = '';
      self.vendor_error_msg = '';
      self.inv_number_error = '';
      self.tank_error_msg = '';


    // if ( self.itemCode == "EXTDIESEL" || self.itemCode == "EXTDEF" ) {
        //allowed price with 0 or null if item is external
    // } else {
    if (!self.tank_mapper_id || self.tank_mapper_id == null || self.tank_mapper_id == "" || !self.tank_mapper_id.value) {
        self.tank_error_msg = "Tank Required.";
        error = true;
    }
    // }

      if (!self.quantity || self.quantity == null || self.quantity == "" || self.quantity==0 ) {
        self.quantity_error_msg = "Quantity Required.";
        error = true;
      }
//        if (!self.cost || self.cost == null || self.cost == "" || self.cost=="0" ) {
//            self.cost_error_msg = "Cost Required.";
//            error = true;
//        }
      if (!self.product_id || self.product_id == null || self.product_id == "" ) {
            self.tank_no_error_msg = "Product Required.";
            error = true;
      }
        if (!self.date_time || self.date_time == null || self.date_time == "" ) {
            self.date_time_error_msg = "Date Required.";
            error = true;
        }

        if (self.is_recieved){
            if ((!self.cost || self.cost == null || self.cost == "" || self.cost=="0") && self.actualRequire == '' ) {
                self.cost_error_msg = "Cost Required.";
                error = true;
            }
            // if ((!self.filesArr.length && !self.existFilesArr.length) && self.actualRequire == '') {
            //     self.fileerror_msg = "File Required.";
            //     error = true;
            // }
        }

        if (self.actualRequire == 'require'){
            if (!self.actual_price || self.actual_price == null || self.actual_price == "" || self.actual_price=="0" ) {
                self.actual_price_error_msg = "Actual Price Required.";
                error = true;
            }
            // if (!self.acfilesArr.length && !self.existacFilesArr.length) {
            //     self.ac_fileerroor_msg = "Actual File Required.";
            //     error = true;
            // }
            // if (self.bill_id == null || !self.bill_id.value) {
            //     self.bill_id_error_msg = "Vendor Invoice Required.";
            //     error = true;
            // }
             if (self.vendor_id == null || !self.vendor_id.value) {
                self.vendor_error_msg = "Vendor Required.";
                error = true;
            }

            if (self.inv_number == null || self.inv_number == '') {
                self.inv_number_error = "Invoice Number Required.";
                error = true;
            }


        }
        if (self.is_recieved){
                if(!self.isUpdate){
                if (!self.docArr.length){
                    self.fileerror_msg = "File Required";
                    error = true;
                }
                }

            if (!self.dropZonePreviewFiles.length && !self.docArr.length ){
                self.fileerror_msg = 'File Required';
                error = true;
            }
        }

       if (self.validateDocs.length > 0) {
         for (var i = 0;i < self.validateDocs.length;i++) {
           let fileObj = self.validateDocs[i];

           if (fileObj.extension != undefined) {
            if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx" || fileObj.extension == "msword" || fileObj.extension == "vnd.openxmlformats-officedocument.wordprocessingml.document") {

             }else{
               self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
               error = true;
             }
           }

           if (fileObj.size != undefined) {
             if(fileObj.size > 10000000){
               self.fileerror_msg = "File size should not be greater than 10 MB.";
               error = true;
             }
           }
         }
       }
         

      if (self.measurement_unit_id == null || !self.measurement_unit_id.value) {
          self.measurement_unit_error_msg = "Measurement Unit  Required.";
          error = true;
      }
      if (self.status == null || !self.status.value) {
          self.status_error_msg = "Status  Required.";
          error = true;
      }
      if (self.user_id == null || !self.user_id.value) {
          self.user_error_msg = "User Required.";
          error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleModelBtn").val("Updating ...");
                $("#createVehicleModelBtn").prop("disabled", true);
                $("#cancelVehicleModelBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);

                }else{

                    $("#createVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);
                }

            }

            const fields = new FormData();

            fields.append("product_id", self.product_id.value);
            fields.append("measurement_unit_id",  self.measurement_unit_id.value);
            if (self.bill_id != null && self.bill_id.value){
                fields.append("bill_id",self.bill_id.value);
            }else{
                fields.append("bill_id",'');
            }
            if (self.vendor_id != null && self.vendor_id.value){
                fields.append("vendor_id",self.vendor_id.value);
            }else{
                fields.append("vendor_id",'');
            }
            fields.append("bill_number",self.inv_number);
            fields.append("status",  self.status.value);
            fields.append("drop_user_id", self.user_id.value);
            fields.append("quantity",  self.quantity);
            fields.append("date_time",  self.date_time);
            fields.append("cost", self.cost);
            fields.append("actual_price", self.actual_price);
            fields.append("is_recieved", self.is_recieved);

            fields.append("federal_diesel_excise_tax", self.federal_diesel_excise_tax);
            fields.append("federal_lust_tax", self.federal_lust_tax);
            fields.append("dsl_fed_enviromental_fee", self.dsl_fed_enviromental_fee);
            fields.append("ca_ab32_env_surcharge", self.ca_ab32_env_surcharge);
            fields.append("tank_mapper_id", self.tank_mapper_id.value);

              // for (var i = 0; i < self.filesArr.length; i++) {
              //     let file = this.filesArr[i];
              //     fields.append("files[]", file);
              // }
            fields.append("files",JSON.stringify(self.docArr));

              for (var j = 0; j < self.acfilesArr.length; j++) {
                  let acfile = self.acfilesArr[j];
                  fields.append("acfiles[]", acfile);
              }

            fields.append("id", segments[3]);

            $.ajax({
                url: process.env.ROOT_API + "/fuel-drop/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                             $("#fuelDropCreate").trigger("reset");
                            self.cost = '';
                            self.measurement_unit_id = null;
                            self.status = {value: "open", text: "Open"};
                            self.quantity=0;
                            self.date_time='';
                            self.product_id=null;
                            self.user_id=null;
                            self.filesArr = [];
                            self.acfilesArr = [];
                            self.federal_diesel_excise_tax =  '';
                            self.federal_lust_tax = '' 
                            self.dsl_fed_enviromental_fee = ''; 
                            self.ca_ab32_env_surcharge = '';
                            self.tank_mapper_id = '';
                            self.is_recieved = false;
    
                            var obj = self.vomArr;
                            $.each(obj, function (key, uomvalue) {
                                if (uomvalue.symbol == 'GAL') {
                                    self.measurement_unit_id = {
                                        value: uomvalue.value,
                                        text: uomvalue.text,
                                    };
                                }
                            });
                        }else{
                            self.$router.push("/fuel-drop/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                // $(".alert-warning").removeClass("show");
                                // $(".alert-warning").addClass("hide");
                                self.common_error_msg = "";
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#fuelDropCreate").trigger("reset");

                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'fuel-drop-create')
                }
            });
      }else{
            self.errorValidationFocus();
      }
    },
    onSearchBill(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'bill');
        }

    },
      loadFuelDrop() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/fuel-drop/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {


                    if(data.content.uom_id == null) {
                        self.measurement_unit_id = null;
                    }else{
                        self.measurement_unit_id = {value: data.content.uom_id, text: self.titleCase(data.content.measurement_unit + " (" + data.content.symbol +")")};
                    }
                    if(data.content.status == 'processed')
                    {
                      self.isNotProcessed = false;
                    }else{
                      self.isNotProcessed = true;
                    }

                     self.status = {
                        value: data.content.status,
                        text: self.titleCase(data.content.status)

                    };

                    if (data.content.status != 'open'){
                        self.is_recieved = true;
                        self.isRequired = 'require';
                    }

                    if(data.content.user_id == null) {
                        self.user_id = null;
                    }else{
                        self.user_id = {value: data.content.user_id, text: self.titleCase(data.content.uFirstName+" "+data.content.uLastName)};
                    }
                    if (data.content.tank_pump_mapper_id == null){

                    }else{
                        self.tank_mapper_id = {value: data.content.tank_pump_mapper_id, text: 'Tank: '+data.content.tank_no};
                    }
                    if(data.content.bill_id == null) {
                        self.bill_id = null;
                    }else{
                        self.bill_id = {value: data.content.bill_id, text: data.content.voucher_number};
                        self.inv_number = data.content.bill_number;
                    }
                    if(data.content.vendor_id == null) {
                        self.vendor_id = null;
                    }else{
                        self.vendor_id = {value: data.content.vendor_id, text: data.content.vendor_code+ ' | '+data.content.vendor_name};
                    }


                    self.quantity=data.content.quantity;
                    self.cost=data.content.cost;
                    self.date_time=data.content.date_time;
                    self.actual_price=data.content.actual_price;

                    if(data.content.product_id == null) {
                        self.product_id = null;
                    }else{
                        self.product_id = {value: data.content.product_id, text:self.titleCase(data.content.company_name + " (" + data.content.loc_code +") | " + data.content.item_name + " | " + data.content.tank_no ),location_id:data.content.location_id};
                        self.loadFieldData(['tank_mapper'],data.content.product_id);
                    }

                    // if (data.content.doc_path != null){
                    //     self.existFilesArr = data.content.doc_path;
                    // }else{
                    //     self.existFilesArr = [];
                    // }
                    if (data.content.doc_path != null){
                      self.dropZonePreviewFiles = data.content.doc_path;
                      self.loadFilesPreview();
                    }else{
                      self.docArr = [];
                      self.validateDocs = [];
                      self.filesArr = [];
                    }
                    if (data.content.actual_doc_path != null){
                        self.existacFilesArr = data.content.actual_doc_path;
                    }else{
                        self.existacFilesArr = [];
                    }
                    // self.existacFilesArr = data.content.actual_doc_path;

                    if (self.existacFilesArr != null && self.existacFilesArr.length > 0){
                        self.acUpadate = true;
                    }

                    self.federal_diesel_excise_tax = data.content.federal_diesel_excise_tax;
                    self.federal_lust_tax = data.content.federal_lust_tax;
                    self.dsl_fed_enviromental_fee = data.content.dsl_fed_enviromental_fee;
                    self.ca_ab32_env_surcharge = data.content.ca_ab32_env_surcharge;
                    // self.cost = data.content.fuel_base_price;

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fuel_drop-by-id')
            }
        });
    },
    onSelectBill:function(){
        var self = this;
        if (self.bill_id != null && self.bill_id.ven_id){
            self.vendor_id = {text:self.bill_id.ven_name,value:self.bill_id.ven_id};
            if (self.bill_id.bill_number != undefined){
                self.inv_number = self.bill_id.bill_number;
            }
        }
    },
    onSelectProduct:function(){
        var self = this;
        var locId = 0;

        if (self.product_id.location_id != undefined){
            locId = self.product_id.location_id;
            self.itemCode = self.product_id.item_code;
        }

        if (self.$route.params.id == undefined){
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/fuel-drop-taxes/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    loc_id:locId
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.federal_diesel_excise_tax = data.content.federal_diesel_excise_tax;
                        self.federal_lust_tax = data.content.federal_lust_tax;
                        self.dsl_fed_enviromental_fee = data.content.dsl_fed_enviromental_fee;
                        self.ca_ab32_env_surcharge = data.content.ca_ab32_env_surcharge;
                        self.cost = data.content.fuel_base_price;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fuel_drop-by-taxes');
                }
            });
        }

        var path = window.location.pathname;
        var segments = path.split("/");
        if (!segments[3]) {
            self.loadFieldData(['tank_mapper'],self.product_id.value);
        }
    },
    afterComplete(file,response){
      var self = this;
    },
    storeDocument(file,response){
      var self = this;
      self.fileerror_msg = "";
      self.filesArr = [];
      self.docArr = [];
      self.validateDocs = [];
      var uploadResponse = response;

      //push doc path in doc array
      self.docArr.push(uploadResponse.content);
      self.filesArr.push(file);
      if (file.type != undefined) {
        var extension = file.type.split("/");
        self.validateDocs.push({
          file_name:file.name,
          size:file.size,
          extension:extension[1]
        });
      }
    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      self.fileerror_msg = "";
      if (file.xhr !== undefined) {
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1],"temp");

        for(var i = 0;i<self.docArr.length;i++){
          if ( self.docArr[i].includes(fileName)) {
            self.docArr.splice(i,1);
            self.validateDocs.splice(i,1);
            self.filesArr.splice(i,1);
          }
        }
      }
    },
    removeFileFromServer(file,flag){
      var self = this;
      var fuelDropId = self.$route.params.id;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/remove-fuel-drop-zone-file",
        type: "POST",
        data: {
          doc_path : file,
          fuel_drop_id: fuelDropId,
          flag:flag
        },
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,true,'vendor-inv-doc-remove')
        }
      });
    },
    loadFilesPreview:function() {
      var self = this;
      self.docArr = [];
      self.validateDocs = [];
      if ( self.dropZonePreviewFiles.length > 0 ) {
        for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
          var url = self.dropZonePreviewFiles[i].url;
          //get file path from url
          self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
          self.validateDocs.push({
            file_name:self.dropZonePreviewFiles[i].display_name,
            extension:self.dropZonePreviewFiles[i].ext
          });
        }
      }
    },
    getFilePathFromUrl (value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;

    },
    deleteFuelDropZoneFile: function(key,file){

      var self = this;
      console.log('prezone files=>',self.dropZonePreviewFiles);
      console.log('Here in deleteFuelDropzoneFile function',file);
      if (confirm('Are you sure that you want to remove file? ')) {
        var fuelDropId = self.$route.params.id;
        if(fuelDropId !== '' && fuelDropId !== undefined){

          self.$parent.loading = true;

          $.ajax({
            url: process.env.ROOT_API + "/remove-fuel-drop-zone-file",
            type: "POST",
            crossDomain: true,
            dataType: "json",
            headers: this.ajxHeaders,
            data: {
              fuel_drop_id:fuelDropId,
              doc_path:file
            },
            success: function(data) {
              self.$parent.loading = false;
              //console.log(data.content[0]["id"]);
              if (data.status == "success") {
                self.filesArr.splice(key,1);
                self.docArr.splice(key,1);
                self.validateDocs.splice(key,1);
                self.loadFuelDrop();
                // $("#myModal").modal("hide");
                // self.$refs.files.value = '';
                // self.existFilesArr = [];
                if (self.valuesFound) {
                  self.valuesFound = false;
                  self.matchingValuesError = [];
                }
              }
            },
            error: function(jqXHR, exception) {
              self.$parent.loading = false;
              self.filesArr.splice(key,1);
              self.docArr.splice(key,1);
              self.validateDocs.splice(key,1);
              self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-doc-remove');
            }
          });

        } else{

          self.filesArr.splice(key,1);
          self.$refs.files.value = '';


        }
      }

    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FuelDropCreate.vue